/** Deferred focus ref — works around Radix returning focus to its trigger after value changes, which overrides autoFocus. */
export function deferredFocusRef(element: HTMLElement | null) {
  if (element) setTimeout(() => element.focus(), 0);
}

export interface ImageDimensions {
  imageHeight: number;
  imageWidth: number;
}

/**
 * Ported from sg-store ProofApprovalHelper.loadImageDimensions, plus approved
 * bug fix #5: revoke the object URL on both load and error (legacy leaked it).
 */
export function loadImageDimensions(artfile?: File): Promise<ImageDimensions> | undefined {
  if (!artfile) return undefined;

  return new Promise((resolve, reject) => {
    const image = new Image();
    const objectUrl = URL.createObjectURL(artfile);
    image.onload = () => {
      URL.revokeObjectURL(objectUrl);
      resolve({ imageWidth: image.naturalWidth, imageHeight: image.naturalHeight });
    };
    image.onerror = errorEvent => {
      URL.revokeObjectURL(objectUrl);
      reject(new Error("Failed to load image dimensions", { cause: errorEvent }));
    };
    image.src = objectUrl;
  });
}
